import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordService } from './../../services/resetpassword.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-reset',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetPasswordComponent implements OnInit {
    resetkey: string;
    model: any = {};
    isLoading = false;
    alert: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private resetService: ResetPasswordService,
    private notificationService: NotificationsService,
  ) { }

  ngOnInit() {
        this.resetkey = this.route.snapshot.queryParams['key'] || '';
  }

  Alert(message: string) {
    this.alert = {
      message: message
    };
  }

  reset() {
      this.isLoading = true;
    this.resetService.reset(this.resetkey, this.model.password)
      .subscribe(result => {
        if (result[0] === true) {
          this.notificationService.success('', 'You have successfully changed the password');
          this.router.navigate(['/login']);
        } else {
          this.Alert(result[1]);
        }
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
      });
  }
}
